// PTR-136: what the per-business 2FA toggle should show.
//
// Two values decide it, both delivered by the business detail response:
//   partner_mandate_2fa  this business's own override, absent when it has none
//   account_mandate_2fa  the partner's account-wide mandate, the fallback
//
// Neither has a safe default. A business with no override under a partner who
// mandates 2FA IS mandated, so assuming `false` before the response lands would
// tell the partner 2FA is off for a business that is in fact enforcing it.
// readTwoFactorMandate therefore reports whether the answer is known at all,
// and the caller shows nothing definitive until it is.

/**
 * The effective state: this business's override when it has one, otherwise the
 * partner's account-wide mandate.
 *
 * @param {boolean|null} override
 * @param {boolean} accountMandate2FA
 * @returns {boolean}
 */
export const isTwoFactorMandated = (override, accountMandate2FA) =>
  typeof override === "boolean" ? override : Boolean(accountMandate2FA);

/**
 * Read both values out of a business detail response.
 *
 * `state` is "ready" only when the response actually carried the account-wide
 * mandate. A backend predating this feature answers without it, and those
 * businesses may well be mandated — so that case is "unsupported", not "off".
 *
 * @param {Object} [data] - the business detail response body
 * @returns {{override: boolean|null, accountMandate2FA: boolean, state: "ready"|"unsupported"}}
 */
export const readTwoFactorMandate = (data) => ({
  override:
    typeof data?.partner_mandate_2fa === "boolean"
      ? data.partner_mandate_2fa
      : null,
  accountMandate2FA: Boolean(data?.account_mandate_2fa),
  state:
    typeof data?.account_mandate_2fa === "boolean" ? "ready" : "unsupported",
});
